import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  faqLink: {
    textDecoration: 'none',
    color: Theme.palette.primary.light,
    marginLeft: '4px',
  },
}));

export default useStyles;
